export default function reducer(
  state = {
    ioFileUpload: '',
  },
  action
) {
  switch (action.type) {
    case 'IO_FILE_UPLOAD_STARTED': {
      return { ...state, changingStatus: 'ongoing' };
    }
    case 'IO_FILE_UPLOAD_SUCCESS': {
      return {
        ...state,
        changingStatus: 'success',
        ioFileUpload: action.payload,
      };
    }
    case 'IO_FILE_UPLOAD_FAILED': {
      return {
        ...state,
        changingStatus: 'failed',
        ioFileUpload: action.payload,
      };
    }
    default: {
      return state;
    }
  }
}
